import { PolygonType } from "#models/questionnaire";
import { isGoogleGeometryLoaded } from "#utils/googleMaps";
import { GoogleLatLng } from '@swyft/map';

/**
 * Returns whether the address falls inside one of the question's service areas.
 *
 * Fails open: without the Maps geometry library we cannot prove the address is outside
 * the area, so we treat it as inside rather than rejecting every lead. Callers that want
 * to react to the library being missing should check `isGoogleGeometryLoaded` themselves.
 */
export const polygonValid = (questionLocation: PolygonType[][], addressValue: GoogleLatLng) => {
  if (!isGoogleGeometryLoaded()) {
    return true;
  }

  let checkLocation = false;
  for (let i = 0; i < questionLocation.length; i++) {
    const polygon = new google.maps.Polygon({ paths: questionLocation[i] });
    const resultCheck = google.maps.geometry.poly.containsLocation(addressValue, polygon);
    if (resultCheck) {
      checkLocation = true;
      break;
    }
  }
  return checkLocation;
};
